import React from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import { EXPERIMENT_UNIFY_POSTS_EMPTY_STATES } from '@wix/communities-blog-experiments';
import withExperiment from '../../hoc/with-experiment';
import withFontClassName from '../../hoc/with-font-class-name';
import withIsFeedDesignEnabled from '../../hoc/with-is-feed-design-enabled';
import withPostBorderWidth from '../../hoc/with-post-border-width';
import styles from './empty-states.scss';

class EmptyStates extends React.Component {
  titleRef = React.createRef();

  // componentDidMount() {
  //   // TODO update after out of iframe, timeout is needed for accessibility audio indication on focus to work
  //   if (this.props.focusOnLoad) {
  //     setTimeout(() => {
  //       if (!this.preventTitleFocus) {
  //         this.titleRef.current && this.titleRef.current.focus();
  //       }
  //     }, 2000);
  //   }
  // }

  render() {
    const {
      title,
      content,
      style,
      className,
      children,
      titleFontClassName,
      contentFontClassName,
      borderWidth,
      isLayoutTextOnImage,
      titleClassName,
      focusOnLoad,
      unifyEmptyStatesExperimentEnabled,
      getPostClassName,
    } = this.props;

    const containerClassName = classNames(
      styles.container,
      contentFontClassName,
      className,
      isLayoutTextOnImage
        ? styles.isLayoutTextOnImage
        : ['blog-card-background-color', 'blog-text-color'],
      'blog-card-border-color',
      getPostClassName('border-color', 'post-container', 'background-color'),
    );

    const titleContainerClassName = classNames(
      titleFontClassName,
      titleClassName,
      unifyEmptyStatesExperimentEnabled &&
        getPostClassName('title-font', 'title-color'),
    );

    const contentContainerClassName = classNames(
      styles.content,
      unifyEmptyStatesExperimentEnabled &&
        getPostClassName('description-font', 'description-color'),
    );

    const titleRef = focusOnLoad && this.titleRef;

    return (
      <div
        data-hook="empty-state-container"
        className={containerClassName}
        style={{ borderWidth, ...style }}
      >
        <div
          className={titleContainerClassName}
          data-hook="empty-states__title"
        >
          <div ref={titleRef} tabIndex="0" className={styles.header}>
            {title}
          </div>
        </div>
        <div className={contentContainerClassName}>
          <div className={styles.description}>{content}</div>
        </div>
        {children && <div className={styles.controls}>{children}</div>}
      </div>
    );
  }
}

EmptyStates.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  isLayoutTextOnImage: PropTypes.bool,
  titleClassName: PropTypes.string,
  focusOnLoad: PropTypes.bool,
  getPostClassName: PropTypes.func.isRequired,
};

EmptyStates.defaultProps = {
  isLayoutTextOnImage: false,
  style: {},
};

export default flowRight(
  withExperiment({
    unifyEmptyStatesExperimentEnabled: EXPERIMENT_UNIFY_POSTS_EMPTY_STATES,
  }),
  withFontClassName,
  withIsFeedDesignEnabled,
  withPostBorderWidth,
)(EmptyStates);
